import { render, staticRenderFns } from "./ClosedSignals.vue?vue&type=template&id=5f360b46&scoped=true"
import script from "./ClosedSignals.vue?vue&type=script&lang=js"
export * from "./ClosedSignals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f360b46",
  null
  
)

export default component.exports